// extracted by mini-css-extract-plugin
export default {"wrapper":"rA-z","addressLine":"sA-z","fullName":"tA-z"};